module.exports = __webpack_public_path__ + "static/mongo-208e2b85e120e5774fe8a89a30671827.jpeg";